import React, { createContext, useCallback, useContext, useEffect, useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { getNavbarConfig } from '../actions/account';

export const initialValues = { navbarConfig: [], footerConfig: [], costCalculatorData: null, globalConfig: null, error: null };
export const NavbarContext = createContext(initialValues);

export const NavbarProvider = ({ children }) => {
  const [navbarConfig, setNavbarConfig] = useState([]);
  const [footerConfig, setFooterConfig] = useState([]);
  const [costCalculatorData, setCostCalculatorData] = useState(null);
  const [globalConfig, setGlobalConfig] = useState(null);
  const [error, setError] = useState(null);

  const updateNavbarConfig = useCallback(async () => {
    try {
      const data = await getNavbarConfig();
      setNavbarConfig(data?.navbar_group);
      setFooterConfig(data?.footer_group);
      setCostCalculatorData(data?.cost_calculator_group);
      setGlobalConfig(data?.tyw_global_group);
      setError(null); // Clear any previous errors on successful fetch
    } catch (e) {
      console.error(e);
      setError('Failed to fetch discount data.');
    }
  }, []);

  useEffect(() => {
    updateNavbarConfig(); // Initial fetch
  }, []);

  const contextValue = useMemo(() => ({ navbarConfig, footerConfig, costCalculatorData, globalConfig, error }), [navbarConfig, footerConfig, costCalculatorData, globalConfig, error]);

  return (
    <NavbarContext.Provider value={contextValue}>
      {children}
    </NavbarContext.Provider>
  );
};

NavbarProvider.propTypes = {
  children: PropTypes.any
};

export const useNavbar = () => useContext(NavbarContext);
